const streamEditor = {
  bindings: {
      streams: '<',
      selection: '<',
      onFormSubmit: '&',
      hasEdit: '<',
      isLocked: '<',
  },
  templateUrl: '/modules/pis-tool/streams/stream-editor/stream-editor.html',
  controller: 'StreamEditorController',
};

angular
    .module('pis-tool.module')
    .component('streamEditor', streamEditor);
